import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'selectCheckbox',
    pure: false,
    standalone: false
})
export class SelectCheckboxPipe implements PipeTransform {

  transform(values: number[], id: number): boolean {
    if (!values) {
      return false;
    }

    return values?.includes(id);
  }

}
